import { Type } from "./Type";
import { Columns } from "../index";
import { IndexViewField } from "../index";
import { FieldRenderProps } from "react-final-form";
import React from "react";

export const IndexField = (columns: Columns) =>
  new Type({
    PresentationComponent: (props: FieldRenderProps<any>) => {
      const v = JSON.stringify(props.input.value);
      return <>{v}</>;
    },
    Component: IndexViewField as any,
    props: {
      columns
    }
  });
